// ==========================
// MOBILE MENU
// ==========================

function initMenu() {

    const toggle = document.querySelector('.header__toggle');
    const mobileNav = document.querySelector('.mobile-nav');
    const overlay = document.querySelector('.overlay');
    const closeBtn = document.querySelector('.mobile-nav__close');

    if (!toggle || !mobileNav || !overlay) return;

    function openMenu() {
        toggle.classList.add('active');
        mobileNav.classList.add('active');
        overlay.classList.add('active');
        document.body.classList.add('no-scroll');
    }

    function closeMenu() {
        toggle.classList.remove('active');
        mobileNav.classList.remove('active');
        overlay.classList.remove('active');
        document.body.classList.remove('no-scroll');
    }

    toggle.addEventListener('click', () => {

        const isOpen = mobileNav.classList.contains('active');

        isOpen ? closeMenu() : openMenu();

    });

    overlay.addEventListener('click', closeMenu);

    if (closeBtn) {
        closeBtn.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', (e) => {

        if (e.key === 'Escape') {
            closeMenu();
        }

    });

    // ==========================
    // ACCORDIONS MOBILE
    // ==========================

    const accordions = document.querySelectorAll(
        '.mobile-nav__accordion'
    );

    accordions.forEach((accordion) => {

        const button = accordion.querySelector(
            '.mobile-nav__accordion-btn'
        );

        if (!button) return;

        button.addEventListener('click', () => {

            accordion.classList.toggle('active');

        });

    });
}

// ==========================
// HEADER SCROLL
// ==========================

function initHeaderScroll() {

    const header = document.querySelector('.header');

    if (!header) return;

    function handleScroll() {

        if (window.scrollY > 20) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

    }

    handleScroll();

    window.addEventListener('scroll', handleScroll);
}

// ==========================
// INIT
// ==========================

document.addEventListener('DOMContentLoaded', () => {

    initMenu();
    initHeaderScroll();

});